import { ListDashboard } from "../../components/User/List/ListDashboard";
import { Content } from "../../components/ui/ContentArea";

export function ListPage() {
	return (
		<Content className="p-5">
			<title>Editar Referencias Consumo</title>
			<ListDashboard />
		</Content>
	);
}
